
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22","cy":"15","r":"2.25"}}),_c('rect',{attrs:{"x":"20.25","y":"20.75","width":"3.5","height":"10.5","rx":"1.75"}}),_c('circle',{attrs:{"cx":"22","cy":"22","r":"15.25"}})])
          )
        }
      }
    